<div class="actionButtons">
    <button mat-raised-button class="btn_green" (click)="goToOverviewPage()">
        Übersicht
    </button>
</div>
<app-model-viewer
    *ngIf="xml && xmlFileIds"
    [xml]="xml"
    [fileIdsForXML]="xmlFileIds"
></app-model-viewer>
